import toPath from 'lodash/toPath'

// Imitates Formik's nested name behavior
// E.g. 'a.b.c' as a field `name` will access values.a.b.c
// See Formik for more info:
// https://formik.org/docs/guides/arrays
function getIn(obj, key, def, p = 0) {
  const path = toPath(key)
  while (obj && p < path.length) {
    obj = obj[path[p++]]
  }
  return obj === undefined ? def : obj
}

export const getErrorProp = (field, errors, touched) =>
  !!getIn(errors, field) && getIn(touched, field)

export const getHelperTextProp = (field, errors, touched, t) => {
  const touchedVal = getIn(touched, field)
  const errorVal = getIn(errors, field)

  return touchedVal && !!errorVal ? t(errorVal.key, errorVal.values) : ' '
}

export const getFieldProps = (field, values, errors, touched, t) => ({
  error: getErrorProp(field, errors, touched),
  helperText: getHelperTextProp(field, errors, touched, t),
  value: getIn(values, field),
})

export const getErrorText = (error, t) => {
  if (!error) {
    return
  }

  return t(error.key, error.values)
}
